<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  add,
  getAirport,
  getDetails,
  update,
  del,
} from "@/api/system/deliveryAging";
import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
import { getCity } from "@/api/system/city";

export default {
  name: "airport",

  components: {
    cTable,
  },
  async mounted() {
    const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "to_country") item.options = to_country;
    });
    this.modals.add.fields.forEach((item) => {
      if (item.key === "to_country") item.options = to_country;
    });
  },
  data() {
    return {
      methods: {
        list: getAirport,
        getDetails,
        del,
        add,
        update,
        getCity,
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              deliver_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              set_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              to_country: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { to_country: 24 },
            { city_id: 24 },
            { deliver_number: 24 },
            { set_time: 24 },
          ],
          fields: [
            {
              name: () => this.$t("DeliveryTimes"),
              key: "deliver_number",
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("DeliveryTimes");
              },
            },
            {
              name: () => this.$t("deliveryAging"),
              key: "set_time",
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("deliveryAging");
              },
            },
            {
              name: () => this.$t("allow_arrive"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("allow_arrive");
              },
              clearable: true,
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async "on-change"({ value, field, fields, formData }) {
                  let country = field.options.find((t) => t.code === value);
                  fields.forEach(async (el) => {
                    if (el.key == "city_id") {
                      if (country) {
                        let res = (await getCity({ country_id: country.id }))
                          .data.payload.rows;
                        el.options = res;
                      } else {
                        el.options = [];
                      }
                      formData[el.key] = "";
                      return;
                    }
                  });
                },
              },
            },
            {
              name: this.$tz("城市"),
              key: "city_id",
              component: "Select",
              placeholder: () => this.$tz("城市"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "",
              config: {
                label: "title",
                value: "id",
              },
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 1519,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        // {
        //   name: "序号",
        //   type: "seq",
        //   align: "center",
        //   width: 50
        // },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center",
        },
        {
          name: () => this.$tz("城市"),
          key: "city_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("DeliveryTimes"),
          key: "deliver_number",
          align: "center",
        },
        {
          name: () => this.$t("deliveryAging"),
          key: "set_time",
          align: "center",
        },

        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 1518,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 1517,
              // bind: {
              //   type: "error"
              // }
            },
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
